export class StripeConfig{
    PublicKey: string;
    SecretKey: string;
}